import { PlatformOS } from 'root-constants'

export function getMobileOperatingSystem(): PlatformOS {
  const { userAgent } = window.navigator

  if (/android/i.test(userAgent)) {
    return PlatformOS.ANDROID
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return PlatformOS.IOS
  }

  return PlatformOS.UNKNOWN
}

/** iPhone / iPad / iPod or Safari-capable macOS (Macintosh). */
export function isAppleOS(): boolean {
  const { userAgent } = window.navigator
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return true
  }
  return /Macintosh|Mac OS X/.test(userAgent)
}
